<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-11-16 14:00:24
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-07 08:55:36
-->
<template>
  <div class="content">
    <el-table :data="machines" style="width: 100%">
      <el-table-column label="序号" width="120" align="center">
        <template slot-scope="scope">
          {{
            (pagination.currentPage - 1) * pagination.pageSize +
            (scope.$index + 1)
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="机具身份码"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-popover
            placement="right"
            title=""
            trigger="hover"
            v-if="scope.row.machineIdentityUrl"
          >
            <img
              :src="scope.row.machineIdentityUrl"
              style="max-height: 200px; max-width: 200px"
            />
            <img
              slot="reference"
              src="@/assets/icon_qr_code.png"
              style="width: 32px; height: 32px"
            />
          </el-popover>
          <p v-else>-</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="categoryName3"
        label="农机品目"
        min-width="6%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="machineryModel"
        label="农机型号"
        min-width="6%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="machineryCode"
        label="出厂编号"
        min-width="6%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="imei"
        label="监控编号"
        min-width="6%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="purchaseDate"
        label="购买时间"
        min-width="6%"
        align="center"
      >
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,prev, pager, next,jumper"
      :page-size="this.pagination.pageSize"
      :total="pagination.recordTotal"
      :hide-on-single-page="true"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      machines: [],
    };
  },
  props: {
    accountId: {
      type: String,
      default: "",
    },
  },
  created() {
    this.getMachineList();
  },
  methods: {
    /**
     * @descripttion: 获取机具列表
     * @Author: juanjuanhui
     * @Date: 2021-11-23 14:04:06
     * @param {*}
     * @return {*}
     */
    getMachineList() {
      let { currentPage, pageSize } = this.pagination;
      let params = { currentPage, pageSize, masterId: this.accountId };
      this.$http.basicInfo.getMachineList(params).then((res) => {
        let { recordTotal, content: machines } = res.data;
        this.pagination.recordTotal = recordTotal;
        this.machines = machines;
      });
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getMachineList();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-popover {
    padding: 30px;
  }
}
</style>
